import { Dialog, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import { EconsultUser, EconsultUtils } from '@oh-vcp/components-common';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { EconsultActionButton } from '@oh-vcp/components-ui';
import EconsultDelegatorSelector from '../econsultDelegatorSelector/EconsultDelegatorSelector';

interface EconsultSelectRequesterDialogProps {
  isDialogOpen: boolean;
  options: EconsultUser[];
  userId: string;
  onConfirm: (userId: string) => void;
  onCancel: () => void;
}

const EconsultSelectRequesterDialog: FC<EconsultSelectRequesterDialogProps> = ({
  isDialogOpen,
  options,
  onConfirm,
  onCancel,
  userId
}) => {
  const { t } = useTranslation();
  const [selectedUserId, setSelectedUserId] = useState<string>(userId);
  const [isError, setIsError] = useState<boolean>(false);
  const isMobile = EconsultUtils.isMobileDevice();

  const handleUserSelected = (usrId: string) => {
    if (usrId && parseInt(usrId, 10) > 0) {
      setIsError(false);
    }
    setSelectedUserId(usrId);
  };

  const handleConfirm = () => {
    if (!selectedUserId || selectedUserId === '0') {
      setIsError(true);
      return;
    }
    setIsError(false);
    onConfirm(selectedUserId);
    setSelectedUserId('0');
  };

  const handleCancel = () => {
    onCancel();
    setSelectedUserId('0');
  };

  return (
    <Dialog open={isDialogOpen}>
      <DialogTitle variant="h2" sx={{ color: 'primary.main' }}>
        {t('Case.requester.selectRequester')}
      </DialogTitle>
      <DialogContent sx={{ width: isMobile ? '80vw' : 400, pb: 3 }}>
        <Typography variant="body2" color="base.grey4" mb={3}>
          {t('Case.requester.actingOnBehalf')}:
        </Typography>
        <EconsultDelegatorSelector
          options={options}
          onUserSelected={handleUserSelected}
          userId={selectedUserId}
        />
        {isError && (
          <Typography variant="body2" color="red">
            Required Field
          </Typography>
        )}
        <Stack direction="row" mt={2} justifyContent="end">
          <EconsultActionButton
            variant="contained"
            color="primary"
            sx={{ mr: 1 }}
            onClick={handleConfirm}
            disabled={!selectedUserId}>
            {t('Case.button.requestConsult')}
          </EconsultActionButton>
          <EconsultActionButton variant="contained" color="primary" onClick={handleCancel}>
            {t('Case.button.cancel')}
          </EconsultActionButton>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default EconsultSelectRequesterDialog;
